export function KpiTile({
  label, value, sub, accent = false, split, onClick, active = false, detail,
}: {
  label: string
  value: string
  sub?: string
  accent?: boolean
  /** Decision 204: the new-business slice of the same figure, shown beneath in the new-business green. */
  split?: { value: string; sub?: string }
  /** Decision 223 (Mark: "Tiles to act as a filter"): a clickable tile — `active` marks the one the table is filtered by. */
  onClick?: () => void
  active?: boolean
  /** A second line of figures under the value (e.g. the ARR / setup split of a backlog). */
  detail?: React.ReactNode
}) {
  const Tag = onClick ? 'button' : 'div'
  return (
    <Tag type={onClick ? 'button' : undefined} onClick={onClick} aria-pressed={onClick ? active : undefined}
      className={`tile ${accent ? 'tile--accent' : ''} ${onClick ? 'tile--button' : ''} ${active ? 'tile--active' : ''}`}>
      <div className="tile__label">{label}</div>
      <div className="tile__value">{value}</div>
      {sub && <div className="tile__sub">{sub}</div>}
      {detail && <div className="tile__detail">{detail}</div>}
      {split && (
        <div className="tile__split" data-testid="tile-split">
          <span className="tile__split-label">New business</span> <strong>{split.value}</strong>{split.sub && <span className="tile__split-sub"> · {split.sub}</span>}
        </div>
      )}
    </Tag>
  )
}

const STATUS_PILL: Record<string, string> = {
  draft: 'pill', sent: 'pill pill--info', viewed: 'pill pill--info',
  accepted: 'pill pill--ok', declined: 'pill pill--stop',
  expired: 'pill pill--warn', superseded: 'pill',
}

export function StatusPill({ status, split = false, splitMode = null, lapsed = false }: { status: string; split?: boolean; splitMode?: string | null; lapsed?: boolean }) {
  // Decision 171: display-only — the underlying status stays 'accepted'; the
  // split marker changes the label, never the value or the colour.
  // Decision 195: a sites-mode split reads "accepted · site deals" — the
  // value was never moved, so "split" would overstate it.
  const label = split && status === 'accepted'
    ? (splitMode === 'sites' ? 'accepted · site deals' : splitMode === 'phases' ? 'accepted · phases' : 'accepted & split')
    // Decision 251: expired inside the open horizon — still open, the price has lapsed.
    : lapsed && status === 'expired' ? 'price lapsed'
    : status
  return <span className={STATUS_PILL[status] ?? 'pill'} title={lapsed && status === 'expired' ? 'Valid Until has passed but the quote is inside the open horizon — still counted as open; Extend to reinstate the price' : undefined}>{label}</span>
}
